<ng-container *ifLoggedIn>
    <a class="page-header__icon"
       routerLink="/account/wishlist"
       routerLinkActive="is-active"
       [attr.aria-label]="'Wishlist quantity ' + wishlist.qty"
       [attr.qty-bullet]="wishlist.qty || undefined"
       cy-wishlistBtnMenu>
        <i class="icon-wishlist"
           aria-hidden="true"></i>
    </a>
</ng-container>

<ng-container *ifNotLoggedIn>
    <a class="page-header__icon"
       [iCmsModalOpen]="LOGIN_FORM_MODAL_ID"
       [attr.aria-label]="'Wishlist - Sign in required'"
       cy-wishlistBtnMenu>
        <i class="icon-wishlist"
           aria-hidden="true"></i>
    </a>
</ng-container>
